<template>
  <li class="space-y-2">
    <h2 class="text-sm font-medium text-gray-500">
      {{ tagCategory.name }}
    </h2>
    <div class="-mx-1">
      <slot :tags="tagCategoryTags" />
    </div>
  </li>
</template>

<script>
export default {
  props: {
    tagCategory: {
      type: Object,
      required: true,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tagCategoryTags() {
      return this.tags.filter((tag) => tag.tagCategoryId === this.tagCategory.id);
    },
  },
};
</script>
